var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { QboFetch } from './qbo-fetch.js';
/**
  * Renders a <select> element with options populated from a JSON array.
  *
  * @remarks
  * This element is a thin wrapper around {@link QboFetch} that renders a <select> element with options populated from a JSON array.
  */
let QboDocViewer = class QboDocViewer extends QboFetch {
    constructor() {
        super(...arguments);
        this.open = false;
        this.loading = false;
        this.renderInHost = false;
    }
    // container: HTMLElement;
    static { this.styles = [
        css `
            /* Add any custom styles here */
            .foo { color: red; }
        `
    ]; }
    async connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return html `<iframe src='sample.pdf' width='100%' height='800px' frameborder='0'></iframe>`;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDocViewer.prototype, "open", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDocViewer.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDocViewer.prototype, "renderInHost", void 0);
QboDocViewer = __decorate([
    customElement('qbo-docviewer')
], QboDocViewer);
export { QboDocViewer };
